import { IBudgetConstruction } from '@apply/api/src/api/ApplyApi';
import { MoneyBox } from '@apply/components';
import { formatCurrencyOrUndefined } from '@apply/ui';
import { ApplicationQuestionReviewItem } from '../../../../components/ApplicationQuestionReviewItem';
import { useBudgetConstructionField } from '../../../../../queries/useBudgetConstructionField';

interface TrussesProps {
    required?: boolean;
    propertyGuid: string;
    isReview?: boolean;
}

export const Trusses: React.FC<TrussesProps> = ({ required = false, propertyGuid, isReview = false }) => {
    const [trusses, set_trusses] = useBudgetConstructionField<number>(
        propertyGuid,
        (b) => b.values?.['Framing']?.['Trusses'] ?? 0,
        (b, v) => ({ ...b, values: { ...b.values, 'Framing': { ...b.values?.['Framing'], 'Trusses': v } } })
    );
    const label = 'Trusses (if not included above)';
    return (
        <>
            {isReview ? (
                <ApplicationQuestionReviewItem
                    label={label}
                    value={formatCurrencyOrUndefined(trusses)}
                />
            ) : (
                <MoneyBox
                    id={'trusses'}
                    allowNegative={false}
                    value={trusses}
                    onChange={(value) => set_trusses(value)}
                    required={required}
                    label={label}
                />
            )}
        </>
    );
};
